import { render } from "./InvoiceAdd.vue?vue&type=template&id=2ebc1031"
import script from "./InvoiceAdd.vue?vue&type=script&lang=js"
export * from "./InvoiceAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__